module.exports = __webpack_public_path__ + "static/media/23.375fd17f.png";